export const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/** Minuti → ore con al massimo 2 decimali, senza zeri inutili (450 → "7.5"). */
export function formatHours(minutes) {
  const hours = Math.round(((Number(minutes) || 0) / 60) * 100) / 100;
  return String(hours);
}

/** Giorni del mese con lettera del giorno, weekend, oggi, passato/futuro. month 1-12. */
export function buildMonthDays(year, month) {
  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const count = new Date(year, month, 0).getDate();
  return Array.from({ length: count }, (_, i) => {
    const date = new Date(year, month - 1, i + 1);
    const dow = date.getDay();
    return {
      day: i + 1,
      label: date.toLocaleDateString('en-GB', { weekday: 'short' }).slice(0, 2),
      weekend: dow === 0 || dow === 6,
      today: date.getTime() === todayStart.getTime(),
      past: date < todayStart,
      future: date > todayStart,
    };
  });
}
